export default function email_verified({next}) {
    const email_verified = localStorage.getItem('email_verified')
    if (email_verified === 'false') {
        return next({
            name: 'email-verify'
        })
    }
    return next()
}
